var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19962 6.41699H0V9.61661H3.19962V6.41699Z",
    fill: "#245864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39884 9.59863H3.19922V12.7982H6.39884V9.59863Z",
    fill: "#245864"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59805 6.39746H6.39844V9.59708H9.59805V6.39746Z",
    fill: "#245864"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7973 3.19922H9.59766V6.39884H12.7973V3.19922Z",
    fill: "#245864"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 0H12.8008V3.19962H16.0004V0Z",
    fill: "#245864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatIcon);
export default __webpack_public_path__ + "static/media/format-icon.5a354ad6287cb9dede692c941c5d3f57.svg";
export { ForwardRef as ReactComponent };